import { Injectable } from '@angular/core';

import { AsyncJobType } from '@recruitee/account-data';
import { AsyncJobConfig } from '@recruitee/async-job';
import { NotificationStyle } from '@recruitee/user-interface';

@Injectable()
export class RemoveSampleDataAsyncJob implements AsyncJobConfig {
  public readonly type = AsyncJobType.RemoveSampleData;
  public readonly showDialog = false;
  public readonly showNotification = true;
  public readonly translations = {
    title: {
      success: 'app.async_jobs.remove_sample_data.title.success.one',
      progress: 'app.async_jobs.remove_sample_data.title.progress.one',
    },
  };

  public readonly skipNotificationMessages = true;
  public readonly notificationConfig = { timeout: 5000 };
  public readonly startNotificationStyle = NotificationStyle.InProgress;
  public readonly workingNotificationStyle = NotificationStyle.InProgress;
}
